import { Button, Text, Flex, Icon, Box, Spinner } from "@chakra-ui/react";
import { MdOutlineContentCopy } from "react-icons/md";
import { HiOutlineExternalLink } from "react-icons/hi";
import { copyToClipboard } from "../utils/copyToClipBoard";

interface TxStatusModalProps {
  transactionWebsite: string;
  openTransaction?: () => void;
  transactionAddress?: string;
}

export const TxStatusModalBody = ({
  transactionWebsite,
  openTransaction,
  transactionAddress,
}: TxStatusModalProps) => {
  return (
    <Flex flexDirection="column" alignItems="center">
      <Box>
        {transactionAddress && (
          <Flex>
            <Text>{transactionAddress}</Text>
            <Button
              variant="link"
              onClick={() => copyToClipboard(transactionAddress)}
              mr="1rem"
              title="Copy transaction hash to clipboard"
            >
              <Icon as={MdOutlineContentCopy} />
            </Button>
          </Flex>
        )}
      </Box>
      <Box my="50px">
        <Spinner size="xl" color="brand.primary" />
      </Box>
      <Box my="0px">
        <Text fontSize="16px">Transaction in process</Text>
      </Box>
      {openTransaction && (
        <Button
          display="flex"
          mt="16px"
          mb="24px"
          onClick={() => openTransaction()}
          fontSize="14px"
          background="brand.primary"
          color="brand.textLight"
        >
          <Icon as={HiOutlineExternalLink} />
          <Text fontWeight="500">View on {transactionWebsite}</Text>
        </Button>
      )}
    </Flex>
  );
};
